<template>
  <div v-if="advisors.length > 0" class="text-xs">
    <table class="table-auto w-full border-collapse border border-gray-200">
      <thead>
        <tr class="bg-gray-100">
          <th class="border border-gray-300 px-4 py-2">Үйлдэл</th>
          <th class="border border-gray-300 px-4 py-2">Нэр</th>
          <th class="border border-gray-300 px-4 py-2">Зураг</th>
          <th class="border border-gray-300 px-4 py-2">Албан тушаал</th>
          <th class="border border-gray-300 px-4 py-2">И-мэйл хаяг</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(advisor, index) in advisors" :key="index">
          <td class="border border-gray-300 px-4 py-2">
            <div class="flex gap-2 justify-center">
              <button
                @click="editadvisor(advisor)"
                class="bg-sky-500 text-white px-2 py-1 rounded"
              >
                <font-awesome-icon icon="fa-solid fa-pen" />
              </button>
              <button
                @click="deleteadvisor(advisor.id, advisor.name)"
                class="bg-red-500 text-white px-2 py-1 rounded"
              >
                <font-awesome-icon icon="fa-solid fa-trash" />
              </button>
            </div>
          </td>
          <td class="border border-gray-300 px-4 py-2 text-center">
            {{ advisor.name }}
          </td>
          <td class="border border-gray-300 px-4 py-2 text-center">
            <img
              :src="advisor.profile"
              alt="Profile"
              class="w-20 h-20 object-contain mx-auto"
            />
          </td>
          <td class="border border-gray-300 px-4 py-2 text-center">
            {{ advisor.position }}
          </td>
          <td class="border border-gray-300 px-4 py-2 text-center">
            {{ advisor.email }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import adminInstance from "@/lib/adminInstance";
import { ref, onMounted } from "vue";

export default {
  name: "MMCouncilTable",
  props: {
    data: Array,
  },
  setup(props, { emit }) {
    const advisors = ref([]);

    onMounted(() => {
      if (props.data) {
        advisors.value = props.data;
      }
    });

    const editadvisor = (advisor) => {
      emit("setMode", "E", advisor);
    };

    const deleteadvisor = async (id, name) => {
      if (!window.confirm(`${name}-г устгах уу?`)) {
        return;
      }

      try {
        const res = await adminInstance.delete(`/delete/about-us?id=${id}`);
        if (res.status === 200) {
          emit("fetchData");
        }
      } catch (err) {
        return err;
      }
    };

    return {
      advisors,
      editadvisor,
      deleteadvisor,
    };
  },
};
</script>
